import type { ViewOption } from '@/engine/app/interfaces.ts';

export const valve: ViewOption = {
  label: 'Valve',
  descriptors: ['valve']
};

export const catheter: ViewOption = {
  label: 'Catheter',
  descriptors: ['catheter']
};

export const leftAtrium: ViewOption = {
  label: 'Left Atrium',
  descriptors: ['left_atrium']
};

export const leftVentricle: ViewOption = {
  label: 'Left Ventricle',
  descriptors: ['left_ventricle']
};

export const rightAtrium: ViewOption = {
  label: 'Right Atrium',
  descriptors: ['right_atrium']
};

export const rightVentricle: ViewOption = {
  label: 'Right Ventricle',
  descriptors: ['right_ventricle']
};

export const rightHeart: ViewOption = {
  label: 'Right Heart',
  descriptors: ['right_heart']
};

export const aorta: ViewOption = {
  label: 'Aorta',
  descriptors: ['aorta']
};

export const pulmonaryArtery: ViewOption = {
  label: 'Pulmonary Artery',
  descriptors: ['pulmonary_artery']
};

export const additionalDevice: ViewOption = {
  label: 'Additional Device',
  descriptors: ['additional_device']
};

export const additionalStructure: ViewOption = {
  label: 'Additional Structure',
  descriptors: ['additional_structure']
};

export const calcification: ViewOption = {
  label: 'Calcification',
  descriptors: ['calcification']
};

export const veins: ViewOption = {
  label: 'Veins',
  descriptors: ['vessel.colored']
};

export const veinsCalcification: ViewOption = {
  label: 'Veins Calcification',
  descriptors: ['vessel_calcification']
};

export const bones: ViewOption = {
  label: 'Bones',
  descriptors: ['bones']
};

export const filter: ViewOption = {
  label: 'Filter',
  descriptors: ['filter']
};

export const hardware: ViewOption = {
  label: 'Hardware',
  descriptors: ['hardware']
};

export const arteriesAndKidneys: ViewOption = {
  label: 'Arteries & Kidneys',
  descriptors: ['arteries_kidneys']
};
